import store from '@/store'

export default [
  {
    path: '/stock-adjustments',
    name: 'stock-adjustment',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock-adjustment/index.vue')
  },
  {
    path: '/stock-adjustments/create',
    name: 'stock-adjustment-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock-adjustment/create.vue')
  },
  {
    path: '/stock-adjustments/:id',
    name: 'stock-adjustment-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock-adjustment/edit_v1.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('stockAdjustment/find', to.params.id)
      next()
    }
  }
]
